import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import 'styles/App.css'
import './styles.scss'
import { hot } from 'react-hot-loader'
import Masthead from '@ta-interaktiv/react-masthead'
import { Selector } from 'components/selector'
import { LoadingIndicator } from 'components/loadingIndicator'
import { ErrorBoundary } from 'components/errorBoundary'
import { Map } from 'components/map'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import ShareButtons, { displayTypes } from '@ta-interaktiv/react-share-buttons'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import { PolymorphicCopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { MotionScale as Scale } from 'components/scale'
import Popup from 'components/popup'
import MunicipalityDetail from 'components/municipalityDetail'
import InteractionCapabilities from 'components/interactionCapabilities'
import { List } from 'components/list'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

const ARTICLE_ID = '17580736'

class AppComponent extends React.Component {
  state = {
    publicationDate: 1
  }

  componentDidMount () {
    const domain = parseHostname().publicationDomain
    window
      .fetch(`https://m.${domain}/api/articles/${ARTICLE_ID}`)
      .then(response => response.json())
      .then(data => {
        this.setState({ publicationDate: data.article.first_published_at })
      })
      .catch(error => {
        console.warn(error)
      })
  }

  render () {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <InteractionCapabilities />
        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Votre paradis fiscal se trouve ici
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='sub header'>
Où votre revenu serait-il le moins imposé ? Notre graphique interactif vous le dira. Déménager de
Baar aux Verrières peut multiplier par sept votre impôt.
              </div>
            </h2>
            <p className='ta author'>
              Fabian Schäfer, Iwan Städler und Kaspar Manz, (Tages-Anzeiger, équipe interactive)
            </p>
          </div>
        </header>

        <main className='ui vertical fitted segment'>
          <div className='ui text container'>
            <p>
Un couple avec deux enfants et deux salaires, par exemple, dont le revenu brut est de Fr. 150&#39;000.-
paiera à Plan-les-Ouates dans le canton de Genève Fr. 11070.- d&#39;impôts cantonaux, communaux et
ecclésiastiques et Fr. 16605.- à Oulens-sous-Échallens dans le canton de Vaud, soit 50% de plus.
            </p>

            <p>
La différence entre le paradis et l&#39;enfer fiscal est flagrant, malgré la péréquation financière. C&#39;est ce
que montrent les données 2017 que l&#39;Administration fiscale fédérale vient de publier sur l&#39;internet.
Cela vaut la peine d&#39;y jeter un regard attentif car votre imposition, qui dépend de vos revenus et de
la composition de votre foyer, varie d’un canton à l’autre. Notre carte interactive vous permet ainsi
de voir en quelques secondes dans quelle commune votre ménage s&#39;en sortirait le mieux. Et la façon
dont votre commune de domiciliation se situe par rapport à ses voisines.
            </p>

          </div>
        </main>

        <aside
          className='ui vertical green segment switzerland-map'
          // onMouseOver={event => this.props.mouseOverHandler(-1, event)}
        >
          <div className='ui container'>
            <h3 className='ui infographic header'>
              Où se trouve votre paradis fiscal ?
            </h3>
            <small style={{display: 'block', lineHeight: '1.2em', opacity: '0.75', marginBottom: '1em'}}><strong>Avertissement</strong>: les données de cette carte datent du mois de juin 2018. Depuis, le conseil d'Etat vaudois a souhaité anticiper l'application de la réforme de la fiscalité des entreprises PF17 dans le canton au début de l'année 2019 et des communes ont revu en conséquence leur fiscalité locale pour l'an prochain. Il est donc possible que pour certaines communes du canton de Vaud, les taux changent.</small>
            <Selector />
            <Scale />
          </div>

          <div style={{ position: 'relative' }}>
            <LoadingIndicator />{' '}
            <ErrorBoundary>
              <div className='' style={{ overflow: 'hidden' }}>
                <Map />
              </div>
            </ErrorBoundary>
          </div>

          <div className='ui container'>
            <div className='ui stackable grid'>
              <div className='two column row'>
                <div className='column'>
                  <Lesebeispiel />
                </div>
                <div className='column'>
                  <div className='ui tiny infographic dividing header'>
                    Chercher la commune
                    <div className='sub header'>
                      Pour comparer plusieurs communes, séparez-les par une virgule; p. ex.{' '}
                      <kbd>Lausanne, Genève, Sion</kbd>.
                    </div>
                  </div>
                  <List />
                </div>
              </div>
            </div>
          </div>
        </aside>

        <main className='ui vertical segment'>
          <div className='ui text container' style={{ position: 'relative' }}>
            <p>
              Les célibataires ayant un revenu brut d'au moins Fr. 150'000.- se trouvent le mieux à Wollerau la
              schwytzoise. Les rentiers ayant un revenu de Fr. 50'000.- paient le plus d'impôt à Schelten la bernoise.
            </p>

            <aside className='ui vertical very fitted segment widescreen hidden large screen hidden small'>
              <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
            </aside>

            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '20%' }}
            >
              <FeedbackMessage
                question='Vous voulez communiquer un renseignement ou vous avez repéré une erreur?'
                call='Envoyez-nous un message à '
                mail='tg.web@sr.tdg.ch'
                project='Votre paradis fiscal se trouve ici'
                mailTo='tg.web@sr.tdg.ch'
              />
            </aside>

            <p>
La plupart des contribuables peuvent quoiqu’il en soit trouver de quoi se réjouir dans l’évolution de
la fiscalité, à la baisse sur dix ans. Les actuels chiffres de la Confédération montrent en effet que la
charge fiscale dans les chefs-lieux de cantons a largement baissé entre 2007 et 2017. Un couple sans
enfant ayant un revenu brut de Fr. 100&#39;000.- paie partout moins d&#39;impôts que dix ans en arrière – à
une exception: Schwytz où un couple paie 0,7% de plus qu&#39;à l&#39;époque, soit Fr. 100.-.
            </p>

            <h3 className='ui small header'>
              Les bas revenus sont généralement avantagés
            </h3>

            <p>
Ce sont les habitants des cantons de Zoug (-37%), de Genève (-29%), de Bâle et de Thurgovie (-17% chacun)
qui sont les plus avantagés. Les impôts des bas revenus ont baissé dans les oasis fiscales (Zoug)
comme dans les cantons à la fiscalité élevée (Genève et Bâle). Les Bernois sont les moins avantagés
car ils paient pratiquement la même chose qu&#39;en 2007.
            </p>

            <div className='dwChart'>
              <img
                src={require('./Entwicklung_Steuerbelastung_2017-2007-desktop.svg')}
                alt=''
                className='ui centered fluid image mobile hidden'
              />
              <img
                src={require('./Entwicklung_Steuerbelastung_2017-2007-mobile.svg')}
                alt=''
                className='ui centered fluid image mobile only'
              />
            </div>

            <p>
Le revenu est tout aussi décisif que le domicile. Les statisticiens de la Confédération ont établi une
comparaison sur dix ans pour des couples sans enfants, dont un seul travaille dans quatre tranches de
revenus: Fr. 50&#39;000.-, Fr. 100&#39;000.-, Fr. 200&#39;000.- et Fr. 400&#39;000.-. Toutes paient moins dans 21 de nos cantons.
Dans la plupart, ce sont bien les plus bas revenus qui paient le moins. C&#39;est le cas dans des cantons
aussi différents que le Valais, Obwald, Saint-Gall, Zurich, Genève ou Bâle.
            </p>

            <div className='dwChart'>
              <img
                src={require('./Absolute_Steuerbelastung_2017-desktop.svg')}
                alt=''
                className='ui centered fluid image mobile hidden'
              />
              <img
                src={require('./Absolute_Steuerbelastung_2017-mobile.svg')}
                alt=''
                className='ui centered fluid image mobile only'
              />
            </div>

            <p>
Quelques rares cantons ont aussi baissé les impôts des hauts revenus très lucratifs pour le fisc. Le
canton d&#39;Uri en est un exemple frappant, baissant en pourcentage l’impôt de la catégorie salariale la
plus élevée deux fois plus que celle des plus bas revenus.
            </p>

            <p>
Les chiffres montrent aussi la vigueur de la concurrence fiscale des dix dernières années. L&#39;écart
entre les paradis et les enfers fiscaux s&#39;en est-il trouvé creusé ? La situation n&#39;est pas uniforme.
L&#39;écart entre le canton le plus cher (Neuchâtel) et le moins cher (Zoug) s&#39;est effectivement creusé
pour les couples ayant Fr. 100&#39;000.- et Fr. 200&#39;000.- de revenu. Mais il a par contre diminué pour les
ménages ayant les revenus les plus élevés.
            </p>

            <p>
Le canton de Schwytz est un bon exemple des limites de la concurrence fiscale. Elles sont fixées par
la péréquation financière nationale (PFN) qui peut sanctionner les réductions fiscales excessives par
des prélèvements fortement accrus. La politique fiscale schwytzoise en est l&#39;illustration. En 2007, le
canton a encore baissé des impôts déjà bas – surtout pour les revenus les plus élevés, mais aussi
pour les autres. Schwytz a dû faire machine arrière en 2013 déjà sous la pression de la PFN.
Aujourd&#39;hui, les impôts pour les quatre classes salariales sont légèrement plus élevés qu&#39;en 2007.
            </p>

            <h3 className='ui small header'>
              Le plan d'Ueli Maurer
            </h3>

            <p>
La plupart des contribuables ne sont pas conscients que les impôts ont généralement baissé. Le
conseiller fédéral Ueli Maurer (UDC) aimerait que ça change. Le ministre des Finances veut aider
l&#39;urgente réforme de la fiscalité des entreprises (PF17), en rappelant publiquement que des baisses
fiscales ont été appliquées aux personnes privées. Ueli Maurer considère que ces baisses sont
largement dues aux entreprises et à l&#39;attractivité de la place économique suisse pour laquelle la
politique fiscale des entreprises est si importante.
            </p>

            <p>
À l&#39;inverse, les partis politiques rose-vert et les responsables de finances communales mettent en
garde contre les augmentations d&#39;impôts sur les personnes physiques que cette réforme entraînera.
Si la fiscalité des entreprises baisse autant que prévu, ils craignent les effets sur les ménages.
            </p>

            <p>
Cela ne s&#39;est pas produit durant la décennie écoulée car les impôts des personnes physiques ont
diminué. La situation diffère selon les cantons mais les revenus fiscaux n&#39;ont en général pas baissé.
Les statistiques financières montrent même le contraire. Les rentrées liées à l&#39;impôt sur le revenu de
tous les cantons ont continué de progresser après 2007, alors que de nombreux cantons ont baissé
leurs impôts et que la crise financière de 2008 était passée par là.
            </p>

            <p>
Il en est de même pour l&#39;impôt fédéral direct. Lors de la décennie écoulée, cette charge a baissé
pour les quatre catégories salariales citées plus haut, et les rentrées ont cependant augmenté de
21%. Une hausse qui ne s&#39;explique pas seulement par l’augmentation de la population de 13%.
            </p>

            <p>
Si l&#39;impôt fédéral n’impacte pas dans le différentiel cantonal, le montant des loyers sur la commune
doit être pris en compte. Pour les bas revenus, le loyer pèse souvent plus que l’impôt. Or, on se loge
moins cher dans les enfers fiscaux que dans les paradis.
            </p>

          </div>
        </main>

        <Popup>
          <MunicipalityDetail />
        </Popup>

        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable inverted grid'>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small inverted infographic table'>
                    <tbody>
                      <tr>
                        <td>Conception et programmation</td>
                        <td>Kaspar Manz, équipe interactive (Tages-Anzeiger)</td>
                      </tr>
                      <tr>
                        <td>Graphiques et programmation</td>
                        <td>
                          Patrick Vögeli et Mathias Lutz, équipe interactive (Tages-Anzeiger)
                        </td>
                      </tr>
                      <tr>
                        <td>Adaptation</td>
                        <td>
                          Olivier Bot (Tribune de Genève)
                        </td>
                      </tr>
                      <tr>
                        <td>Données</td>
                        <td>Administration fédérale des contributions</td>
                      </tr>
                      <tr>
                        <td>Publié le</td>
                        <td>
                          <TimestampFormatter
                            timestamp={this.state.publicationDate}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Actualisé le</td>
                        <td>
                          <TimestampFormatter
                            timestamp={window.project.buildTimestamp}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Version</td>
                        <td>{window.project.version}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage
                    question='Vous voulez communiquer un renseignement ou vous avez repéré une erreur?'
                    call='Envoyez-nous un message à '
                    project='Votre paradis fiscal se trouve ici'
                    mail='tg.web@sr.tdg.ch'
                    mailTo='tg.web@sr.tdg.ch'
                  />
                  <div className='ui fluid share aligned container'>
                    <ShareButtons articleId={ARTICLE_ID} />
                  </div>
                </div>
                <div className='column'>
                  <div className='ui fluid copyright container'>
                    <PolymorphicCopyrightNotice />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

function Lesebeispiel () {
  return (
    <div className='content'>
      <div className='ui tiny infographic dividing header'>Exemple de lecture</div>
      <div className='description'>
        <p>
          <strong>À Genève et à Bâle</strong>, un couple dont un seul travaille avec un <strong>revenu de Fr.&nbsp;50&#39;000.-</strong> ne paiera quasi
          pas d’impôts (respectivement Fr.&nbsp;25.- et Fr.&nbsp;160.-, sans l&#39;impôt fédéral direct) alors qu’il paiera <strong>Fr.&nbsp;1584.-
          à Lausanne</strong>.
        </p>
        <p>Ce montant peut varier en fonction des déductions.</p>
        <p>
          L'impôt sur la fortune et l'impôt fédéral, qui est identique dans toutes les communes, n'ont pas été pris en
          compte dans ce calcul.
        </p>
      </div>

      <div className='ui center aligned vertical segment'>
        <ShareButtons
          displayType={displayTypes.HORIZONTAL_BUTTONS}
          articleId={ARTICLE_ID}
        />
      </div>
    </div>
  )
}

export default hot(module)(AppComponent)



// WEBPACK FOOTER //
// ./src/components/main/index.js